import { render, staticRenderFns } from "./DocumentPurchasePrint.vue?vue&type=template&id=633f3108&scoped=true"
import script from "./DocumentPurchasePrint.vue?vue&type=script&lang=js"
export * from "./DocumentPurchasePrint.vue?vue&type=script&lang=js"
import style0 from "./DocumentPurchasePrint.vue?vue&type=style&index=0&id=633f3108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633f3108",
  null
  
)

export default component.exports